import React from "react";
import { Modal, Avatar } from "antd";
import { UserOutlined } from "@ant-design/icons";

const ReactionUserList = ({ visible, onClose, emoji, users, messageId }) => {
  return (
    <Modal
      open={visible}
      onCancel={onClose}
      footer={null}
      width={400}
      className="reaction-user-list-modal"
      title={
        <div className="reaction-modal-header">
          <span className="reaction-emoji-header">{emoji}</span>
          <span className="reaction-count-header">{users?.length || 0}</span>
        </div>
      }
    >
      <div className="reaction-user-list">
        {users && users.length > 0 ? (
          users.map((user, index) => (
            <div key={user.id || index} className="reaction-user-item">
              <Avatar
                src={user.image}
                icon={<UserOutlined />}
                size={40}
                className="user-avatar"
              />
              <div className="user-info">
                <span className="user-name">{user.name || "Unknown User"}</span>
              </div>
            </div>
          ))
        ) : (
          <div className="no-users">
            <p>No users have reacted with {emoji}</p>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default ReactionUserList;
